module.exports = __webpack_public_path__ + "static/img/banner.c1c20d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wrap-img/banner.svg
// module id = o+co
// module chunks = 1